import { Button, message, Table } from 'antd'
import PopupDetail from './PopupDetail'
import CreatAfterSale from './CreatAfterSale'
import { useState } from 'react'
import { connect } from 'react-redux'
import AuthComponent from '../../../components/AuthComponent'
/**
 *
 * @param {Array} list 表格数据
 * @param {String|Number} total 数据总条数
 * @param {Object} page pageIndex:页码 pageSize:页面大小
 * @param {Function} submit 切换页码时的方法
 * @param {Boolean} loading 数据是否加载中
 * @param {Array} orderChan 订单来源对应转换数组（store）
 * @returns
 */
const OrderTable = ({
  list,
  total,
  page = {},
  submit,
  searchList = () => {},
  loading,
  orderChan,
  orderType,
  rootProps
} = {}) => {
  const columns = [
    {
      title: '下单时间',
      dataIndex: 'orderTime',
      key: 'orderTime',
      align: 'center',
      width: 150
    },
    {
      title: '发货时间',
      dataIndex: 'deliveryTime',
      key: 'deliveryTime',
      align: 'center',
      width: 150
    },
    {
      title: '订单来源',
      dataIndex: 'chan',
      key: 'chan',
      align: 'center',
      width: 120,
      render: text =>
        ((orderChan || []).filter(item => item.code == text)[0] || {}).name ||
        text
    },
    {
      title: '订单类型',
      dataIndex: 'orderType',
      key: 'orderType',
      align: 'center',
      width: 120,
      render: text =>
        ((orderType || []).filter(item => item.code == text)[0] || {}).name ||
        text
    },
    {
      title: '订单号',
      dataIndex: 'orderNo',
      key: 'orderNo',
      align: 'center',
      width: 180
    },
    {
      title: '购买人姓名',
      dataIndex: 'buyerName',
      key: 'buyerName',
      align: 'center',
      width: 120,
      render: text => text || '-'
    },
    {
      title: '购买人电话',
      dataIndex: 'buyerPhone',
      key: 'buyerPhone',
      align: 'center',
      width: 120,
      render: text => text || '-'
    },
    {
      title: '所属门店',
      dataIndex: 'storeName',
      key: 'storeName',
      align: 'center',
      width: 200
    },
    {
      title: '收货人姓名',
      dataIndex: 'receiverName',
      key: 'receiverName',
      align: 'center',
      width: 120,
      render: text => text || '-'
    },
    {
      title: '收货人电话',
      dataIndex: 'receiverPhone',
      key: 'receiverPhone',
      align: 'center',
      width: 120,
      render: text => text || '-'
    },
    {
      title: '收货地址',
      dataIndex: 'receiverDetailAddr',
      key: 'receiverDetailAddr',
      align: 'center',
      width: 200,
      render: text => text || '-'
    },
    {
      title: '核销码',
      dataIndex: 'verifyCode',
      key: 'verifyCode',
      align: 'center',
      width: 120,
      render: text => text || '-'
    },
    {
      title: '商品数量',
      dataIndex: 'productCount',
      key: 'productCount',
      align: 'center',
      width: 100
    },
    {
      title: '实付金额',
      dataIndex: 'payAmount',
      key: 'payAmount',
      align: 'center',
      width: 120
    },
    {
      title: '支付渠道',
      dataIndex: 'payWayDesc',
      key: 'payWayDesc',
      align: 'center',
      width: 120
    },
    {
      title: '配送方式',
      dataIndex: 'receiveWay',
      key: 'receiveWay',
      align: 'center',
      width: 120,
      render: text => text || '-'
    },
    {
      title: '订单状态',
      dataIndex: 'orderStatusName',
      key: 'orderStatusName',
      align: 'center',
      width: 120,
      render: (text, record, index) => (
        <span>{ record.orderStatusName == '部分发货' ? '待发货' : record.orderStatusName }</span>
      )
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      fixed: 'right',
      width: 150,
      render: (text, record) => (
        <>
          <AuthComponent authKey='/order/info/{orgOrderNo}'>
            <Button type='link' onClick={() => toDetail(record)}>
              查看
            </Button>
          </AuthComponent>
          {[2, 3].includes(record.orderType) &&
          ['wait_delivery', 'wait_take', 'grouped', 'finish'].includes(record.orderStatus) &&
          record.canAftersale ? (
            <AuthComponent authKey='/order/info/{orgOrderNo}'>
              <Button type='link' onClick={() => toAfterSale(record)}>
                申请售后
              </Button>
            </AuthComponent>
          ) : (
            ''
          )}
        </>
      )
    }
  ]
  const [showDetail, setShowDetail] = useState(false)
  const [detail, setDetail] = useState({})
  const [showAfterSale, setShowAfterSale] = useState(false)

  const toDetail = info => {
    // setShowDetail(true)
    // setDetail(info)
    rootProps.history.push(
      `/order-delivery/detail?orderNo=${info.orderNo}&orderStatus=${info.orderStatus}`)
  }
  const toAfterSale = info => {
    setShowAfterSale(true)
    setDetail(info)
  }
  // 判断是否展示 申请售后按钮
  const showAfterSaleBtn = (record) => {
    let flag = true
    /* if(['wait_delivery', 'finish'].includes(orderStatus)) {
      
    }

    if(record.orderStatus == 'orderStatus') {
      message.warning('部分发货不支持申请售后')
    } */

    return flag
  }
  
  return (
    <>
      <Table
        size='middle'
        loading={loading}
        bordered
        columns={columns}
        dataSource={list}
        rowKey='orderNo'
        scroll={{ x: 2300 }}
        pagination={{
          showQuickJumper: true,
          showSizeChanger: true,
          pageSize: page.pageSize,
          current: page.pageIndex,
          total,
          showTotal: total => `当前条件共检索到 ${total} 条信息`,
          onChange: (pageIndex, pageSize) => submit({ pageIndex, pageSize })
        }}
      />
      <PopupDetail
        visible={showDetail}
        onClose={() => setShowDetail(false)}
        detail={detail}
      />
      <CreatAfterSale
        visible={showAfterSale}
        onClose={() => setShowAfterSale(false)}
        detail={detail}
        showList={searchList}
        hide={() => setShowAfterSale(false)}
      />
    </>
  )
}

export default connect(state => ({
  orderChan: state.order.orderChan,
  orderType: state.order.orderType
}))(OrderTable)
